/**
 * Header Component
 * Main application header with logo and navigation
 */

import React from 'react';

import { POLinkButton } from '@prizeout/prizeout-ui';

import { useAppSelector, useStorefrontAuth } from '../../hooks';
import { selectIsAuthenticated } from '../../store/slices';

import './header.scss';

export interface HeaderProps {
    showLogout?: boolean;
}

export const Header: React.FC<HeaderProps> = ({ showLogout = true }) => {
    const { performLogout } = useStorefrontAuth();
    const isAuthenticated = useAppSelector(selectIsAuthenticated);
    const isDesktop = window.innerWidth > 879;

    return (
        <header className="header">
            <div className="header__inner">
                <div className="header__logo">
                    <a href="https://prizeout.com/" target="_blank" rel="noopener noreferrer">
                        {isDesktop ? (
                            <img
                                src="https://assets.prizeout.com/branding/po-logo-full-blue.svg"
                                alt="Prizeout logo"
                                className="header__logo-image"
                            />
                        ) : (
                            <img
                                src="https://assets.prizeout.com/branding/po-logo-small.svg"
                                alt="Prizeout logo"
                                className="header__logo-image header__logo-image--mobile"
                            />
                        )}
                    </a>
                </div>

                <div className="header__actions">
                    <a
                        href="https://help.prizeout.com/hc/en-us"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="header__link"
                    >
                        Contact Us
                    </a>

                    {showLogout && isAuthenticated && <POLinkButton label="Log Out" onClick={performLogout} />}
                </div>
            </div>
        </header>
    );
};

export default Header;
